import React, { useEffect, useState } from 'react';
import './Login.scss';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginEmployee } from '../../services/userServices';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../redux/slice/userSlice';
import { toAuthState } from '../../dto/auth.dto';
import Footer from '../Footer/Footer';
import logoIUH from '../../image/Logo_IUH.png';

const Login = () => {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [userCode, setUserCode] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isValidUserCode, setIsValidUserCode] = useState(true);
    const [isValidPassword, setIsValidPassword] = useState(true);

    const handleLogin = async () => {
        setIsValidUserCode(true);
        setIsValidPassword(true);

        if (!userCode.trim()) {
            toast.error('Vui lòng nhập mã người dùng!');
            setIsValidUserCode(false);
            return;
        }
        if (!password.trim()) {
            toast.error('Vui lòng nhập mật khẩu!');
            setIsValidPassword(false);
            return;
        }

        try {
            const response = await loginEmployee(userCode, password, 'Employee');

            const authState = toAuthState(response, 'user');
            if (authState) {
                toast.success(response.message || response.message || 'Đăng nhập thành công!');
                dispatch(login(authState));
                navigate('/employee/parking-lots');
            } else if (response?.error || response?.message) {
                toast.error(response?.error?.message || response.message);
            }
        } catch (err) {
            toast.error('Đăng nhập thất bại. Vui lòng kiểm tra lại kết nối!');
        }
    };

    const handlePressEnter = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    useEffect(() => {
        if (user && user.isAuthenticated) {
            navigate("/employee/parking-lots");
        }
    }, [user, navigate]);

    return (
        <div className="login-page-wrapper">
            <div className="login-card">
                <div className="row g-0">
                    {/* Hero Brand Side */}
                    <div className="col-lg-5 login-hero-side d-none d-lg-flex">
                        <div>
                            <div className="hero-badge">
                                <img src={logoIUH} alt="Logo IUH" style={{ height: 22, width: 'auto', background: '#fff', borderRadius: 4, padding: '2px 4px' }} />
                                IUH Parking
                            </div>
                            <h2>Hệ Thống Quản Lý Bãi Xe Thông Minh</h2>
                            <p>
                                Giải pháp gửi xe tự động tích hợp nhận diện biển số AI, thẻ RFID và thanh toán ví điện tử nhanh chóng.
                            </p>
                            <div className="feature-list">
                                <div className="feature-item">
                                    <i className="bi bi-check-circle-fill"></i>
                                    <span>Tra cứu tình trạng chỗ đỗ thời gian thực</span>
                                </div>
                                <div className="feature-item">
                                    <i className="bi bi-check-circle-fill"></i>
                                    <span>Quản lý phương tiện & lịch sử ra vào</span>
                                </div>
                                <div className="feature-item">
                                    <i className="bi bi-check-circle-fill"></i>
                                    <span>Thanh toán tự động bằng ví điện tử</span>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 small opacity-75">
                            Trường Đại học Công nghiệp TP.HCM - IUH
                        </div>
                    </div>

                    {/* Form Side */}
                    <div className="col-lg-7 login-form-side">
                        <div className="form-title">
                            <h4>Đăng nhập Nhân viên</h4>
                            <p>Nhập thông tin tài khoản để truy cập hệ thống bãi xe</p>
                        </div>

                        <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                            <div className="form-group-custom">
                                <label>Mã tài khoản (User Code / Mã SV)</label>
                                <div className="input-wrapper">
                                    <i className="bi bi-person input-icon"></i>
                                    <input
                                        type="text"
                                        className={isValidUserCode ? '' : 'is-invalid'}
                                        placeholder="Nhập mã nhân viên"
                                        value={userCode}
                                        onChange={(e) => setUserCode(e.target.value)}
                                        onKeyDown={handlePressEnter}
                                        autoComplete="username"
                                    />
                                </div>
                            </div>

                            <div className="form-group-custom">
                                <label>Mật khẩu</label>
                                <div className="input-wrapper">
                                    <i className="bi bi-lock input-icon"></i>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className={isValidPassword ? '' : 'is-invalid'}
                                        placeholder="Nhập mật khẩu của bạn..."
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onKeyDown={handlePressEnter}
                                        autoComplete="current-password"
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>

                            <button type="submit" className="btn-login-submit mt-3">
                                ĐĂNG NHẬP HỆ THỐNG
                            </button>
                        </form>

                        <div className="login-footer-links">
                            <Link to="/employee/forgot-password">Quên mật khẩu?</Link>
                            <Link to="/employee/parking-lots">Về trang chủ</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
